import MixingFunctions from '../components/MixingFunctions';
// import GridItens from '../components/template2/GridItens';
import ListItens from '../components/template2/ListItens';

new Vue({
    el: '#main-content',
    mixins: [
        MixingFunctions
    ],
    components: {
        'stretch': VueLoadingSpinner.Stretch,
        ListItens
    },
    data: {
        baseLink: window.vueData.baseLink,
        corLoading: window.vueData.corLoading,
        loading: true,
        itens: window.vueData.itens,
        marca: window.vueData.marca,
        storage: window.vueData.storage,
        marcasEspeciais: window.vueData.marcasEspeciais,
        bannersLateral: window.vueData.bannersLateral,
        paramsFiltrado: {
            able: true,
            start: true
        },
        paramsNormal: {
            filtro: window.vueData.inicial,
            start: true
        },
        filtrado: true,
        letraSelecionada: window.vueData.inicial,
        letras: [
            '0-9',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ]
    },
    methods: {
        goToLink (item) {
            if (item.link !== '') {
                document.location.href = item.link;
            }
        },
        goTo (slug) {
            document.location.href = '/loja/' + slug;
        },
        getClass (letra) {
            return {
                'no-round-btn': true,
                'smooth': true,
                'internal': true,
                // 'pt-1': true,
                'active': this.letraSelecionada === letra
            };
        },
        atualizaLista (letra) {
            this.letraSelecionada = letra;
            this.paramsNormal.filtro = letra;
            this.$nextTick(() => {
                this.$refs.listItens.$refs.vuetable.refresh();
            });
        },
        showGrid (type) {
            if (type === 'able') {
                this.filtrado = true;
                this.paramsFiltrado.able = true;
                this.paramsFiltrado.start = true;
                this.$nextTick(() => {
                    this.$refs.listItensFiltrado.$refs.vuetable.refresh();
                });
                return;
            }

            this.filtrado = false;
            this.paramsNormal.start = true;
            this.$nextTick(() => {
                this.$refs.listItens.$refs.vuetable.refresh();
            });
        }
    }
});
